import * as React from 'react'
import { useState } from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import numberFormat from '../../../services/data/numberFormat'
import media from '../../../services/generateMediaQueries'
import GenericDownloadAppModal from '../../../components/home/GenericDownloadAppModal/GenericDownloadAppModal'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
`

const RewardItem = styled.div`
  flex: 0 0 auto;

  background: #ffffff;
  border-radius: var(--border-radius-form);
  box-shadow: var(--box-shadow-form);

  height: 95px;

  margin-bottom: 0.75rem;

  display: flex;
  align-items: center;
  overflow: hidden;

  cursor: pointer;

  &:last-child {
    margin: 0;
  }
`

const RewardsDescription = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1rem;
`

const RewardDetails = styled.div``

const RewardTitle = styled.h3`
  font-size: 1.125rem;
  margin: 0;

  ${media.lessThan('small')`
    font-size: 0.875rem;
  `}
`

const RewardPoints = styled.p`
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  margin: 0;
  color: var(--color-primary);

  ${media.lessThan('small')`
    font-size: 0.75rem;
  `}
`

const RewardImage = styled.img`
  border-radius: var(--border-radius-form);
  object-fit: cover;
  align-self: normal;
  width: 95px;
`

function RewardsList(props) {
  const [displayDownloadAppModal, setDisplayDownloadAppModal] = useState(false)

  const {
    data,
    accessToken,
    advanceAccount,
    redeemRewardObject,
    showRedeem,
    history,
    displayProfileModal,
    setProfileModalPage,
    setRedirectAfterAuth,
    ...restProps
  } = props

  return (
    <Container {...restProps}>
      {Array.isArray(data) &&
        data.map(reward => (
          <RewardItem
            key={reward.id}
            onClick={() => setDisplayDownloadAppModal(true)}
          >
            <RewardImage src={reward.imageUrl} />
            <RewardsDescription>
              <RewardDetails>
                <RewardTitle>{reward.title}</RewardTitle>
                <RewardPoints>{numberFormat(reward.points)} pts</RewardPoints>
              </RewardDetails>
            </RewardsDescription>
          </RewardItem>
        ))}
      <GenericDownloadAppModal
        show={displayDownloadAppModal}
        onClose={() => setDisplayDownloadAppModal(false)}
        zIndex={10025}
      />
    </Container>
  )
}

RewardsList.defaultProps = {
  data: [],
}

RewardsList.propTypes = {
  data: PropTypes.array,
}

export default RewardsList
